<template>
  <v-dialog
    v-model="computedSnowmakingHydrantVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('snowmaking', 'hydrants', false);
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span class="hidden-sm-and-down"
            >Hydrant #{{ computedHydrntNum }}</span
          >
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- zoomto icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates[0],
                level: 18
              });
              methodCloseListLayer('snowmaking', 'hydrants');
              methodToggleSingleLayer('snowmaking', 'hydrants', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>

        <!-- forward/back buttons -->
        <!-- forward buttons -->
        <v-tooltip bottom>
          <!-- previous hydrant button enabled -->
          <v-btn
            v-if="computedPreviousHydrant"
            icon
            slot="activator"
            @click="
              methodToggleSingleLayer(
                'snowmaking',
                'hydrants',
                'true',
                computedPreviousHydrant
              )
            "
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <!-- next hydrant button disabled -->
          <v-btn v-if="!computedPreviousHydrant" disabled icon slot="activator">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <span>Previous hydrant</span>
        </v-tooltip>
        {{ computedRun }}
        <!-- forward button -->
        <v-tooltip bottom>
          <!-- next hydrant button enabled -->
          <v-btn
            v-if="computedNextHydrant"
            icon
            slot="activator"
            @click="
              methodToggleSingleLayer(
                'snowmaking',
                'hydrants',
                'true',
                computedNextHydrant
              )
            "
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <!-- next hydrant button disabled -->
          <v-btn v-if="!computedNextHydrant" disabled icon slot="activator">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <span>Next hydrant</span>
        </v-tooltip>

        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            v-if="disable_edit"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            slot="activator"
            color="info"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <v-data-table
          :items="computedSnowmakingHydrantGeoJsonFeature"
          :loading="computedSnowmakingHydrantsLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Hydrant #</td>
              <td>
                <v-text-field
                  ref="hyd_hydrnt_num"
                  name="hydrnt_num"
                  v-model="props.item.properties.hydrnt_num"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>30A</td>
              <td>
                <v-select
                  ref="hyd_30a"
                  :items="opt_aw3060"
                  v-model="props.item.properties['30a']"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>60A</td>
              <td>
                <v-select
                  ref="hyd_60a"
                  :items="opt_aw3060"
                  v-model="props.item.properties['60a']"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Water</td>
              <td>
                <v-select
                  :items="opt_aw3060"
                  ref="hyd_water"
                  v-model="props.item.properties.water"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Air</td>
              <td>
                <v-select
                  :items="opt_aw3060"
                  ref="hyd_air"
                  v-model="props.item.properties.air"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Circuit</td>
              <td>
                <v-text-field
                  name="circuit"
                  ref="hyd_circuit"
                  v-model="props.item.properties.circuit"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Power Source Description</td>
              <td>
                <v-text-field
                  name="elec_maint"
                  ref="hyd_elec_maint"
                  v-model="props.item.properties.elec_maint"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Tower Type</td>
              <td>
                <v-select
                  :items="opt_tower_type"
                  ref="hyd_tower_type"
                  v-model="props.item.properties.tower_type"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Last Edit</td>
              <td v-if="disable_edit">{{ props.item.properties.edit_by }}</td>
              <td v-if="!disable_edit">{{ computedAuth.profile.email }}</td>
            </tr>
            <tr>
              <td>Last Edit</td>
              <td v-if="props.item.properties.modified">
                {{ props.item.properties.modified }}
              </td>
            </tr>
            <tr>
              <td>Lat/Lng</td>
              <td>
                {{ props.item.geometry.coordinates[0][1] }},
                {{ props.item.geometry.coordinates[0][0] }}
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  name="hyd_notes"
                  ref="hyd_notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditSnowmakingHydrantGeoJson({
                      hydrnt_num: $refs.hyd_hydrnt_num.value,
                      '30a': $refs.hyd_30a.value,
                      '60a': $refs.hyd_60a.value,
                      air: $refs.hyd_air.value,
                      water: $refs.hyd_water.value,
                      circuit: $refs.hyd_circuit.value,
                      tower_type: $refs.hyd_tower_type.value,
                      elec_maint: $refs.hyd_elec_maint.value,
                      notes: $refs.hyd_notes.value,
                      edit_by: computedAuth.profile.email,
                      modified: new Date(Date.now()).toISOString()
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('snowmaking', 'hydrants', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              methodDeleteSnowmakingHydrantGeoJson();
              confirm_delete = false;
              disable_edit = true;
              methodToggleSingleLayer('snowmaking', 'hydrants', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      disable_edit: true,
      confirm_delete: false,
      solo: true,
      opt_aw3060: [
        { text: "0", value: "0" },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" }
      ],
      opt_source: [
        { text: "Unknown" },
        { text: "CAD/GPS" },
        { text: "Eye Balled" }
      ],
      opt_tower_type: [
        { text: "N/A", value: "0" },
        { text: "1" },
        { text: "2" },
        { text: "3" }
      ]
    };
  },
  computed: {
    computedLatLng() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson.features
      ) {
        const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        const result = hydrants.filter(
          item => item.properties.id == this.computedSnowmakingHydrantId
        );
        return result;
      }
      return [];
    },
    computedHydrntNum() {
      if (this.computedSnowmakingHydrantVisibility) {
        const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        // grabs the hydrnt_num of the currently viewed ID
        let result = hydrants.filter(
          item => item.properties.id == this.computedSnowmakingHydrantId
        );
        return result[0].properties.hydrnt_num;
      }
      return [];
    },
    computedRun() {
      if (this.computedSnowmakingHydrantVisibility) {
        const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        // grabs the trail_name of the currently viewed ID
        let result = hydrants.filter(
          item => item.properties.id == this.computedSnowmakingHydrantId
        );
        return result[0].properties.trail_name;
      }
      return [];
    },
    computedSameRun() {
      // returns an alphabetically sorted list of hydrnt_nums and ids of hyds on the same run as current hyd
      if (this.computedSnowmakingHydrantVisibility) {
        let hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        // Gets all entries that are on the same trail as the currently viewed ID
        let result = hydrants.filter(
          item => item.properties.trail_name == this.computedRun
        );
        // Constructs JSON obj of hydrnt_num: id key value pairs
        let o = [{}];
        for (let i = 0; i < result.length; i++) {
          o[i] = {};
          o[i].hydrnt_num = result[i].properties.hydrnt_num;
          o[i].id = result[i].properties.id;
        }
        // sorts constructed json by hydrnt_num alphabetically
        let sortedHydrnt_num = o.sort((a, b) => {
          a = a.hydrnt_num.toLowerCase();
          b = b.hydrnt_num.toLowerCase();

          return a < b ? -1 : a > b ? 1 : 0;
        });

        return sortedHydrnt_num;
      }
      return [];
    },
    computedNextHydrant() {
      if (this.computedSnowmakingHydrantVisibility) {
        // define the array
        let arr = [];
        // loop through hydrants on the same run
        for (let i = 0; i < this.computedSameRun.length; i++) {
          // push hydrants that are next to the array
          if (this.computedHydrntNum < this.computedSameRun[i].hydrnt_num) {
            arr.push(this.computedSameRun[i].id);
          }
        }
        // return the next hydrant only
        if (typeof arr[0] !== "undefined") {
          return arr[0];
        } else {
          return false;
        }
      }
      return [];
    },
    computedPreviousHydrant() {
      if (this.computedSnowmakingHydrantVisibility) {
        // define the array
        let arr = [];
        // loop through hydrants on the same run
        for (let i = 0; i < this.computedSameRun.length; i++) {
          // push hydrants that are next to the array
          if (this.computedHydrntNum > this.computedSameRun[i].hydrnt_num) {
            arr.push(this.computedSameRun[i].id);
          }
        }
        // reverse the order of the array
        let arrrev = arr.reverse();
        // return the next hydrant only
        if (typeof arrrev[0] !== "undefined") {
          return arrrev[0];
        } else {
          return false;
        }
      }
      return [];
    },
    computedSnowmakingHydrantGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson.features
      ) {
        const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        const result = hydrants.filter(
          item => item.properties.id == this.computedSnowmakingHydrantId
        );
        return result;
      }
      return [];
    },
    computedSnowmakingHydrantVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.visibility
        .singleView;
    },
    computedSnowmakingHydrantsLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.loading;
    },
    computedSnowmakingHydrantId() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingHydrantGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
        dept: "snowmaking",
        layer: "hydrants",
        token: this.computedAuthToken
      });
    },
    methodDeleteSnowmakingHydrantGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants/" +
            this.computedSnowmakingHydrantId,
          dept: "snowmaking",
          layer: "hydrants",
          token: this.computedAuthToken
        })
        .then(() => {
          this.methodGetSnowmakingHydrantGeoJson();
        });
    },
    methodEditSnowmakingHydrantGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants/" +
          this.computedSnowmakingHydrantId,
        dept: "snowmaking",
        layer: "hydrants",
        token: this.computedAuthToken,
        payload: data
      });
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.hydrants.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingHydrantGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.hydrants.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
